export default __webpack_public_path__ + "static/media/Checkmark.0f454ba2.svg";